export { FiltersItemCondition as default };

/**
* Filters Item Condition Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersItemCondition {

  /**
   * Field Name
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  field;

  /**
   * Condition test
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  test;

  /**
   * Condition Type
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  type;

  /**
   * Conditirion Value
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  value;
}